<div *ngIf="ensayo">
    <span *ngIf="esMuestraBase" [class]="enumTdStatusClass[estadoAnalisis]">
        <div class="d-flex align-items-center">         
            <span>{{valorResultadoFormateado}}</span>
        </div>
    </span>
    <span *ngIf="!esMuestraBase">
            {{valorResultadoFormateado}}
    </span>
</div>